import { orderUploadStyles } from "@insite/content-library/Components/OrderUpload";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

orderUploadStyles.fileUploader = {
    buttonProps: {
        variant: "secondary",
        css: css`
            ${TypographyStyle} {
                font-family: "Roboto-Medium";
            }
        `,
    },
    cssOverrides: {
        formField: css`
            justify-content: flex-end;
        `,
    },
};
orderUploadStyles.downloadTemplateButton = {
    css: css`
        margin-bottom: 15px;
        font-family: "Roboto-Medium";
    `,
    variant: "primary",
};

orderUploadStyles.cancelUploadButton = {
    variant: "secondary",
    css: css`
        font-family: "Roboto-Medium";
        float: right;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 100%;
                    `,
                ],
                "max",
            )}
    `,
};

orderUploadStyles.uploadFileButton = {
    css: css`
        float: right;
        font-family: "Roboto-Medium";
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        margin-bottom: 10px;
                        width: 100%;
                    `,
                    css`
                        margin-left: 15px;
                        width: initial;
                    `,
                ],
                "min",
            )}
    `,
};
